import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Row from './Row';

import './ModalTable.pcss';

const tableHtmlRegex = /<td[^>]*>(.*?)<\/td>/;
class ModalTable extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      filtered: props.corrected
    };

    this.handleFilter = this.handleFilter.bind(this);
  }

  handleFilter(checked) {
    this.setState({
      filtered: checked
    });
  }

  render() {
    const { filtered } = this.state;

    const getType = item => {
      if (item.mark === item.max_mark) {
        return 'correct';
      }
      if (item.mark === 0) {
        return 'incorrect';
      }

      return 'partial';
    };

    const { data, className, gve, tablesHtml } = this.props;

    const dataWithFlags = data.map(item => ({
      ...item,
      type: getType(item)
    }));

    const rows = dataWithFlags.filter(
      item => !filtered || item.type !== 'correct'
    );

    const tablesWithTasks = {};

    tablesHtml.forEach(tableHtml => {
      // Достаем название таблицы
      const tableHeader = tableHtml.match(tableHtmlRegex);
      const tableName = tableHeader ? tableHeader[1] : '';
      // Ищем все задания в таблице
      const regex = /<td[^>]*TaskName="([^"]*)"[^>]*>/g;
      let match;
      while ((match = regex.exec(tableHtml)) !== null) {
        const taskName = match[1];
        // Ищем задание в списке выбранных заданий
        const dataItem = rows.find(item => item.task_name === taskName);
        // Если задание найдено, то добавляем его в список заданий для данной таблицы
        if (dataItem) {
          // Если таблица еще не создана, то создаем ее
          if (!tablesWithTasks[tableName]) {
            tablesWithTasks[tableName] = [];
          }
          // Добавляем задание в таблицу
          tablesWithTasks[tableName].push(dataItem);
        }
      }
    });

    return (
      <div className={cn('ModalTable', className)}>
        {Object.entries(tablesWithTasks).map(
          ([tableName, tasks]) =>
            tasks.length > 0 && (
              <div className="Table__answers">
                <div className="Table__header">{tableName}</div>
                <div className="Table__answers-header">
                  <div className="Table__answers-header-wrapper">
                    <div
                      className={`Table__answers-header-item Table__answers-header-item--for-desktop`}
                    >
                      № задания
                    </div>
                    <div
                      className={`Table__answers-header-item Table__answers-header-item--for-mobile`}
                    >
                      Задание
                    </div>
                    {!tasks[0].detailed && (
                      <>
                        <div className="Table__answers-header-item Table__answers-header-item-answer Table__answers-header-item--for-desktop">
                          Ваш ответ
                        </div>
                        <div className="Table__answers-header-item Table__answers-header-item-answer Table__answers-header-item--for-mobile">
                          Ответ
                        </div>
                      </>
                    )}
                    <div className="Table__answers-header-item Table__answers-header-item-mark Table__answers-header-item--for-desktop">
                      {gve ? 'Ваша оценка' : 'Ваш балл'}
                    </div>
                    <div className="Table__answers-header-item Table__answers-header-item-max-mark Table__answers-header-item--for-desktop">
                      {gve ? 'Макс. оценка' : 'Макс. балл'}
                    </div>
                    <div className="Table__answers-header-item Table__answers-header-item-mark-max-mark Table__answers-header-item--for-mobile">
                      {gve ? 'Оценка' : 'Баллы'}
                    </div>
                  </div>
                </div>
                <div className="Table__answers-body">
                  {tasks.map(item => (
                    <Row key={item.task_number} item={item} span />
                  ))}
                </div>
              </div>
            )
        )}
      </div>
    );
  }
}

ModalTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      answer: PropTypes.string,
      number: PropTypes.string,
      mark: PropTypes.number,
      max_mark: PropTypes.number,
      checked: PropTypes.bool
    })
  ).isRequired,
  gve: PropTypes.bool,
  className: PropTypes.string,
  tablesHtml: PropTypes.array
};

ModalTable.defaultProps = {
  className: '',
  gve: false,
  tablesHtml: []
};

export default ModalTable;
